// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"718":"06a7ffd9","851":"67c3c103"}[chunkId] + ".chunk.js";
};